import { ComponentType, ReactNode } from 'react';

import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import { ConversationsV2ToolConfirmationResponseDecision } from '@spotify/confidence-graphql';

export type ToolGroupEntry = {
  tool: string;
  eventName?: string;
  displayName?: string | null;
  input?: unknown;
  result?: { content: string; success: boolean };
};

export type PreviewField = {
  key: string;
  label?: string;
};

export interface ToolConfirmationRenderProps {
  input: unknown;
  onDecide: (decision: ConversationsV2ToolConfirmationResponseDecision) => void;
  actionsDisabled: boolean;
  pendingDecision: ConversationsV2ToolConfirmationResponseDecision | null;
  error?: Error | null;
}

export interface ToolExtensionOptions
  extends ItemRenderExtensionOptions<string> {
  icon?: ComponentType<{ size?: number | string; style?: object }>;
  display?: 'prominent' | 'grouped';
  formatLabel?: (entry: ToolGroupEntry) => { text: string; detail?: string };
  renderLabel?: (entry: ToolGroupEntry) => ReactNode;
  renderTool?: (entry: ToolGroupEntry) => ReactNode;
  previewFields?: PreviewField[];
  confirmationTitle?: string;
  renderConfirmation?: (props: ToolConfirmationRenderProps) => ReactNode;
}

export const ToolExtensions = createItemRenderExtensions<ToolExtensionOptions>({
  id: 'tool',
});

export const createToolExtension = (options: ToolExtensionOptions) => {
  return createItemRenderExtension<ToolExtensionOptions>(options);
};

export const useToolExtensions = () => {
  return useItemRenderExtensions<ToolExtensionOptions>(ToolExtensions);
};
